export default {"src":"/_next/static/media/blueprint.3b5f3c46.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};